import React from 'react';
// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ControlledTabs from '../../components/Tabs';
import './FAQ.css';
import { CustomTypoLighth3 } from '../../helper/headings';
import SignupRectangle from '../../components/signup_rectange';
import AppNavBar from '../../helper/appbar';

const FAQ = () => {
    return (
        <div>
            <AppNavBar navType={'_light'} />
            <section className='banner-gradient faq-banner'>
                <Container>
                    <Row>
                        <Col md={6} lg={6} xl={7}>
                            <h1>Hi there!</h1>
                            <h2>Do you need any help today?</h2>
                            <p>We're here to help you get started with the support you need.
                                Visit our FAQs or get in touch with our support team.</p>
                        </Col>
                        <Col md={6} lg={6} xl={5}>
                            <div className='faq-banner-section2'>
                                <CustomTypoLighth3 typo={`Available 24/7`} />
                                <h4>Available now!</h4>
                                <CustomTypoLighth3 typo={`Tel: +234 802 5198 619`} />
                                <CustomTypoLighth3 typo={`Whatsapp: +234 802 5198 619`} />
                                <CustomTypoLighth3 typo={`Wecare@gokardinal.com`} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Container className='faq-section-2'>
                <Row>
                    <Col>
                        <h1 className='custom-typo-dark'>Frequently Asked Questions</h1>
                        <ControlledTabs />
                    </Col>
                </Row>
            </Container>
            <SignupRectangle />
        </div>
    );
};

export default FAQ;